import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import './App.css';

import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Coleccion from './pages/Coleccion';
import Restaurantes from './pages/Restaurantes';
import Proyectos from './pages/Proyectos';
import Galeria from './pages/Galeria';
import Contacto from './pages/Contacto';
import Cotizacion from './pages/Cotizacion';

function LenisProvider({ children }) {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const lenis = new Lenis({
      lerp: 0.1,
      wheelMultiplier: 1,
      smoothTouch: false,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <CartProvider>
      <LenisProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
            <Header />
            <CartDrawer />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/coleccion" element={<Coleccion />} />
                <Route path="/restaurantes" element={<Restaurantes />} />
                <Route path="/proyectos" element={<Proyectos />} />
                <Route path="/galeria" element={<Galeria />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/cotizacion" element={<Cotizacion />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </LenisProvider>
    </CartProvider>
  );
}

export default App;
